import { LanguageIcon, MailIcon, GithubIcon, PhoneIcon } from "./icons"
import {
  Block,
  Work,
  Project,
  Contact,
  useNavi,
  useInfo,
  useFull,
} from "./components"

export default function ResumeEN() {
  const navi = useNavi()
  const info = useInfo()
  const full = useFull()
  return (
    <>
      <LanguageIcon className="lang" onClick={() => navi("/zh")} />
      <h1>Abel Yao</h1>
      <p className="subtitle">
        15 Years Work Experience, Career Objective: Full-Stack / Front-End
      </p>
      <Block title="Contact">
        {info && <Contact icon={<PhoneIcon />}>180-1279-5566</Contact>}
        <Contact icon={<MailIcon />}>abelyao@live.com</Contact>
        <Contact icon={<GithubIcon />}>
          <a href="https://github.com/yb" target="_blank">
            https://github.com/yb
          </a>
        </Contact>
      </Block>
      <Block title="Skills">
        <p>Excellence on TypeScript, React, Vue, Node.js</p>
        <p>Proficient with Next.js, AI-SDK, Nuxt, Fastify, Shadcn UI</p>
        <p>Experienced on MongoDB, Redis, Nginx</p>
      </Block>
      <Block title="Work Experience">
        <Work
          company="Molplus AI"
          title="Agent Full-stack Engineer"
          start="2026.2"
          end="Now"
        >
          <p>
            Independently led the front-end design and development of the
            company's core AI Agent product, with additional contributions to
            backend API development. Built with React Router and TypeScript, the
            product features a fully-featured streaming chat experience, task
            space management, multi-format in-browser preview, DAG graph
            visualization, project member management, wallet top-up, and
            subscription plan management. Implemented a dual-edition
            distribution design with Standard and Enterprise editions.
          </p>
          <p>
            The project leveraged Claude Code, Codex, Cursor, and other AI
            coding tools through vibe coding workflows, enabling rapid delivery
            from concept to initial production release.
          </p>
        </Work>
        <Work
          company="Single Particle"
          title="Software Engineer"
          start="2024.9"
          end="2025.10"
        >
          <p>
            Developed a 4D-STEM analysis desktop client using React and
            Electron. The application executed Python analysis algorithms for
            data processing and visualization. Additionally, the application
            implemented an online update and multi-language support using
            i18next.
          </p>
          <p>
            Developed a machine status monitoring tool that polled equipment
            status via RPC interfaces and triggered email and WeCom alerts upon
            exceeding configured thresholds.
          </p>
        </Work>
        <Work
          company="XDXCT"
          title="Software Engineer"
          start="2023.1"
          end="2024.9"
        >
          <p>
            Utilized front-end frameworks (React, Vue, Electron, X6, ECharts) to
            develop software supporting integrated circuit design processes,
            including task workflow management, data analysis, and circuit
            design.
          </p>
          <p>
            Spearheaded all front-end technology selection and evaluation.
            Provided leadership and mentorship to junior developers. Contributed
            to the overall architectural design for select projects.
          </p>
          <p>
            Contributed to a yield data collection and monitoring platform,
            deploying data collection agents at foundry sites to relay key
            metrics such as yield rates back to the central server for real-time
            alerts, reporting, and visualization.
          </p>
        </Work>
        <Work
          company="Silicon Therapeutics"
          title="Senior Front-end Engineer"
          start="2020.5"
          end="2022.7"
        >
          <p>
            As the first web developer in the team, I lead to design and develop
            a visualization platform with data graphs and 3D molecular display
            in close collaboration with the R&D team, which is a pure original
            web-based platform to visualize all the deep scientific computation
            tools and features, to use another presenting way to show the drug
            discovery methods, help end-user to easily handle all the functions
            and tools and read the result report on the platform directly.
          </p>
          <p>
            React and Ant Design in the front-end part and RDKit and NGL viewer
            in 2D/3D molecular display, Plotly.js in formatting scientific
            charts, Egg.js framework and Sequelize ORM library in the back-end
            part. Additionally, a computing cluster monitor was developed using
            Next.js.
          </p>
          <p></p>
        </Work>
        <Work
          company="Independent developer"
          title="Full-stack"
          start="2017"
          end="2020"
        >
          <p>
            Because of my passion for programming, I tried startup in 2017 and
            became a full stack engineer. During this period, I developed
            several websites, WeChat official accounts, and WeChat mini program.
            I shared some open-source projects on Github and achieved 1400+
            stars recognition. I have kept learning new skills, in both
            front-end and back-end, thus perfecting my skill tree, and enjoying
            programming from it.
          </p>
        </Work>
        <Work
          company="Jinbaihui Information"
          title="Software engineer"
          start="2012.4"
          end="2015.2"
          onlyFull
        >
          <p>
            Developed a multi-merchant e-commerce platform using ASP.NET and SQL
            Server.
          </p>
          <p>
            Developed the event registration system, player management system
            and official website for Shantou Sports Bureau using C# and SQL
            Server.
          </p>
        </Work>
        <Work
          company="Landray Technology"
          title="Software engineer"
          start="2011.4"
          end="2012.3"
          onlyFull
        >
          <p>
            Developed the marketing platform for China Mobile using ASP.NET.
          </p>
          <p>
            Developed the OA system and components for China Mobile using
            ASP.NET.
          </p>
        </Work>
      </Block>
      <Block title="Personal Projects">
        <Project name="IMAGEN" desc="WeChat Miniprogram">
          <p>
            IMAGEN is an image generation tool where users describe their ideas
            in natural language and upload reference images to generate
            high-quality images across multiple styles. It comes with built-in
            support for GPT 4o, GPT Image 2, Nano Banana Pro, Seedream, and
            other mainstream image models.
          </p>
          <p>
            The highlight of this project is its agent-driven approach to task
            routing and parameter orchestration - an LLM decomposes user input
            into atomic tasks and intelligently matches parameter combinations,
            reducing the need for complex form operations. The backend uses
            Fastify + BullMQ to implement an async task queue, ensuring reliable
            image generation through polling, and automatically downloads
            results to Alibaba Cloud OSS for faster user access while avoiding
            server bandwidth consumption.
          </p>
        </Project>
        <Project name="Firefly">
          <p>
            Firefly is a general-purpose online agent platform built primarily
            on the AI-SDK. It features complete streaming event handling,
            including resumable stream recovery on refresh, tool execution
            status display and approval, and custom event push. The agent is
            driven by a ToolLoopAgent with built-in tools for web search, web
            content fetching, and bash command execution, along with a
            Docker-based sandbox environment that supports file read/write and
            code execution. The platform also integrates BullMQ for distributed
            task queuing, improving execution stability for long-running tasks,
            with status tracking and real-time progress feedback.
          </p>
        </Project>
        <Project
          name="Fotodata"
          desc={
            <a href="https://fotodata.app/" target="_blank">
              https://fotodata.app/
            </a>
          }
        >
          <p>
            An online tool for analyzing photo data directly in the browser. It
            requires no software installation or server uploads, and can parse
            RAW photos from over 200 camera models. The tool generates
            multi-dimensional statistical charts, including line graphs, pie
            charts, and bar charts. It leverages Web Workers and WebAssembly for
            performance optimization, enabling the analysis of over 40,000
            photos in approximately 30 minutes. The project was also launched on
            Product Hunt for promotion.
          </p>
        </Project>
        <Project name="H5Cafe" desc="WeChat official account">
          <p>
            Over 6,000,000 page views, 500,000 unique visits, 100,000 online
            visitors, and 600 gigabytes of website traffic, in a single day.
            This is a mobile web game I individually developed, which has gained
            180,000 followers within 6 months. The server side only uses one
            Windows Server with 4GB memory. Benefiting from the separation of
            the front-end and back-end, I deliver static resources through CDN
            to reduce the HTTP requests to the server. Also, I use Redis to
            cache some data to reduce the SQL Server load. This project includes
            online payments.
          </p>
        </Project>
      </Block>
      <Block title="Education">
        <p>
          Bachelor degree in Computer Science and Technology, Huazhong
          University of Science and Technology
        </p>
        <p>College degree in Software Technology, Shantou University</p>
      </Block>
    </>
  )
}
